// OT Verification endpoint: https://admincenter.devxprod.ot2.opentext.com/mc/api/ets/v1/signup/verify-recaptcha

declare global {
    interface Window {
        recaptchaValid: boolean;
        recaptchaValidate: (token: string) => Promise<void>;
        recaptchaLoad: () => void;
        grecaptcha?: {
            render: (
                id: string,
                options: {
                    sitekey: string;
                    callback: (token: string) => void;
                    tabindex: number;
                    theme: string;
                }
            ) => void;
            reset: (opt_widget_id?: string) => void;
        };
    }
}

export const otRecaptcha = {
    appendScript($form: HTMLFormElement) {
        window.recaptchaLoad = () => {
            otRecaptcha.load($form);
        }

        if (!window.grecaptcha) {
            var script = document.createElement("script");
            script.defer = true;
            script.src = "https://www.google.com/recaptcha/api.js?onload=recaptchaLoad&render=explicit";
            $form.append(script);
        }
    },
    load($form: HTMLFormElement) {
        const { $recaptcha, $submitBtn, captchaId } = this.getTargets($form);
        const siteKey = $recaptcha.getAttribute("data-ot-sitekey");
        const validationEndpoint = $recaptcha.getAttribute("data-ot-endpoint");

        if (!siteKey || !validationEndpoint) return;

        // The tabindex property of gcaptcha.render options does not seem to work. Need to do this instead:
        setTimeout(() => {
            const $iframe = $recaptcha?.querySelector("iframe");

            if ($iframe) {
                // Remove from tabbing order since it is not in the first step/slide of the form
                // (Toggled in SP10_1-form_multistep.ts depending active state of the slide)
                $iframe.tabIndex = -1;
            }
        });

        // Only the captcha (not the other inputs) affects ariaDisabled state of button, so default to true on captcha load
        $submitBtn.ariaDisabled = "true";

        window.grecaptcha?.render(captchaId, {
            sitekey: siteKey,
            callback: (token) => this.validateRecaptcha(validationEndpoint, token, $form),
            tabindex: -1,
            theme: "dark",
        });
    },
    getTargets($form: HTMLFormElement) {
        const $recaptcha = $form.querySelector(".g-recaptcha");
        const captchaId = $recaptcha?.id;

        const $submitBtn = $form?.querySelector(
            "[data-ot-form-submit]"
        ) as HTMLButtonElement;

        return { $recaptcha, $submitBtn, captchaId };
    },
    async validateRecaptcha(endpoint: string, token: string, $form: HTMLFormElement) {
        const requestBody = {
            "g-recaptcha-response": token,
        };

        const request: RequestInit = {
            method: "POST",
            body: JSON.stringify(requestBody),
            headers: {
                "Content-Type": "application/json",
            },
            mode: "cors",
        };

        const $status = $form.querySelector('[data-ot-form-status]');
        
        const recaptchaValidatedEvent = new CustomEvent('grecaptcha-validated', {
            // detail: { message: '' },
        });
        
        document.dispatchEvent(recaptchaValidatedEvent);

        // Not doing server side validation for now

        // try {
        //     const response = await fetch(endpoint, request);

        //     if (!response.ok) {
        //         throw new Error(`Server error: ${response.status}`);
        //     }

        //     const data = await response.json();

        //     if (data.success) {
        //         const recaptchaValidatedEvent = new CustomEvent('grecaptcha-validated', {
        //             // detail: { message: '' },
        //         });

        //         document.dispatchEvent(recaptchaValidatedEvent);

        //         if ($status) {
        //             $status.innerHTML = ``;
        //         }

        //     } else {
        //         const errorText = "reCAPTCHA validation failed";
        //         console.warn(errorText, data.errors);

        //         if ($status) {
        //             $status.innerHTML = `<p class="text-error text-sm">${errorText}</p>`;
        //         }

        //         window.grecaptcha?.reset();
        //     }
        // } catch (error) {
        //     const errorText = "reCAPTCHA validation request failed";
        //     console.error(errorText, error);

        //     if ($status) {
        //         $status.innerHTML = `<p class="text-error text-sm">${errorText}</p>`;
        //     }

        //     window.grecaptcha?.reset();
        // }
    }
};
